/**
 * @generated SignedSource<<3d30d85034c3483cc2a8dbea89e3d112>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbleShare_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSocialShareEmail_item" | "PdpSharedSocialShareFacebook_item" | "PdpSharedSocialSharePinterest_item">;
  readonly " $fragmentType": "PdpRespIconBubbleShare_item";
};
export type PdpRespIconBubbleShare_item$key = {
  readonly " $data"?: PdpRespIconBubbleShare_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbleShare_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbleShare_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSocialSharePinterest_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSocialShareFacebook_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSocialShareEmail_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "f22831facc6fcf92492368b642c5f685";

export default node;
